export async function formatSource (value) {
  const source = value || ''
  if (!source.trim()) return source

  try {
    const [prettierModule, parserBabelModule] = await Promise.all([
      import('prettier/standalone.js'),
      import('prettier/parser-babel.js')
    ])
    const prettier = prettierModule.default || prettierModule
    const prettierParserBabel = parserBabelModule.default || parserBabelModule
    return prettier.format(source, {
      parser: 'babel',
      plugins: [prettierParserBabel],
      printWidth: 100,
      tabWidth: 2,
      singleQuote: true,
      semi: false,
      trailingComma: 'none'
    })
  } catch {
    throw new Error('Unable to format — check for syntax errors')
  }
}
